module.exports = __webpack_public_path__ + "76ca72ebb05bbcf45357a0b152e0e566.jpeg";